import { put, call, takeLatest } from 'redux-saga/effects'

import { EXPENSE_CATEGORY_PARAM } from 'Constants'
import {
  createTag as createExpenseCategoryApi,
  deleteTag as deleteExpenseCategoryApi,
  getTags as getExpenseCategoriesApi,
} from 'Service/Api'

import * as ExpenseCategoryTypes from 'Redux/Types/ExpenseCategoryTypes'
import * as ExpenseCategoryActions from 'Redux/Actions/ExpenseCategoryActions'

function* deleteExpenseCategory({ payload }) {
  try {
    yield call(deleteExpenseCategoryApi, payload)
    yield put(ExpenseCategoryActions.deleteExpenseCategorySucceeded(payload))
  } catch (errors) {
    yield put(ExpenseCategoryActions.deleteExpenseCategoryFailed(errors))
  }
}

function* createExpenseCategory({ payload }) {
  const { searchTerm, resolve, reject } = payload
  const params = {
    value: searchTerm,
    type: { name: EXPENSE_CATEGORY_PARAM },
  }
  try {
    const { data } = yield call(createExpenseCategoryApi, params)
    yield put(ExpenseCategoryActions.addExpenseCategorySucceeded(data))
    if (resolve) {
      resolve(data)
    }
  } catch (errors) {
    yield put(ExpenseCategoryActions.addExpenseCategoryFailed(errors))
    if (reject) {
      reject(errors)
    }
  }
}

function* getExpenseCategories() {
  try {
    const { data } = yield call(getExpenseCategoriesApi, EXPENSE_CATEGORY_PARAM)
    yield put(ExpenseCategoryActions.getExpenseCategoriesSucceeded(data))
  } catch (errors) {
    yield put(ExpenseCategoryActions.getExpenseCategoriesFailed(errors))
  }
}

export default function* ExpenseCategorySaga() {
  yield takeLatest(ExpenseCategoryTypes.DELETE_EXPENSE_CATEGORY, deleteExpenseCategory)
  yield takeLatest(ExpenseCategoryTypes.GET_EXPENSE_CATEGORIES, getExpenseCategories)
  yield takeLatest(ExpenseCategoryTypes.ADD_EXPENSE_CATEGORY, createExpenseCategory)
}
